import React from "react";
import AnimatedIcon from "../Components/Animatedicons";
import { Link } from "react-router-dom";
import Wrapper from "../Components/Wrapper";

function PageNotFound() {
  return (
    <Wrapper>
      <div className="h-100">
        <Link to={"/"}>
          <AnimatedIcon name={"error"} />
        </Link>
      </div>
    </Wrapper>
  );
}

export default PageNotFound;
